<template>
  <v-btn
    icon
    flat
    @click="confirmation = true"
    class="post-delete-button"
    title="Видалити"
  >
    <v-icon>delete</v-icon>
    <v-dialog
      v-model="confirmation"
      max-width="400"
    >
      <v-card>
        <v-card-title class="headline">Бажаєте видалити цей пост?</v-card-title>
        <v-card-text>Видалений пост не може бути відновлений.</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat @click="confirmation = false">Відмінити</v-btn>
          <v-btn color="primary" flat @click="remove">Видалити</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-btn>
</template>

<script>

import { removePost } from '@/firebase/repositories/posts';

export default {
  name: 'PostDeleteButton',
  props: {
    postId: {
      required: true,
    },
  },
  data() {
    return {
      confirmation: false,
    };
  },
  methods: {
    remove() {
      removePost(this.postId)
        .then(this.$router.replace({ name: 'home' }));
    },
  },
};

</script>



// WEBPACK FOOTER //
// src/components/PostDeleteButton.vue